module.exports = __webpack_public_path__ + "img/bookme-logo-white.4c260d70.png";